/**
 * Core global JS.
 */
import { ComponentManager } from 'js-component-framework';
import contentTypeList from 'components/contentTypeList';
import curatedShare from 'components/curatedShare';
import faq from 'components/faq';
import gallery from 'components/gallery';
import header from 'components/header';
import objectFitImages from 'object-fit-images';
import search from 'components/search';
import searchPageFilter from 'components/searchPageFilter';
import searchPageSubmitCheckboxes from 'components/searchPageSubmitCheckboxes';
import tableOfContents from 'components/tableOfContents';
import tocMove from 'components/tocMove';
import topicContentList from 'components/topicContentList';
import topicsNav from 'components/topicsNav';
import newsletter from 'components/newsletter';
import employeeDetail from 'components/employeeDetail';
import subnav from 'components/subnav';

import 'components/footer';
import 'components/subheader';

import 'scss/index.scss';

import './index.scss';

const manager = new ComponentManager('knight-foundation-app');

function initComponents() {
  // Add data-component to default WordPress image gallery.
  const galleryInstances = document.querySelectorAll('.blocks-gallery-grid');
  Array.prototype.forEach.call(galleryInstances, (galleryItem) => {
    galleryItem.setAttribute('data-component', 'Gallery');
  });
  // Init all other components.
  // IMPORTANT: This list should be ordered top-down by DOM position.
  window.setTimeout(() => {
    manager.initComponents([
      search,
      searchPageFilter,
      searchPageSubmitCheckboxes,
      header,
      topicsNav,
      tocMove,
      contentTypeList,
      curatedShare,
      employeeDetail,
      faq,
      gallery,
      newsletter,
      topicContentList,
    ]);
  }, 1);
  // Set the subnav to fire later to make sure necessary content has loaded
  window.setTimeout(() => {
    manager.initComponents([
      subnav,
      tableOfContents,
    ]);
  }, 800);
}

document.addEventListener('DOMContentLoaded', () => {
  initComponents();
});

if (module.hot) {
  module.hot.accept();
  initComponents();
}

objectFitImages();
